import styled from "styled-components";

export const LoginContainer = styled.div`
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  min-width: 20rem;
`;

export const LoginContainerHeader = styled.h1`
  font-weight: bold;
  text-align: center;
`;

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
